/**
 * Copyright © Veeam Software Group GmbH.
 */

import { JobTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type JobTypes = JobTypeRepresentation;
export const JobTypes = JobTypeRepresentation;
